// Copyright © 2024 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { addonsRegistry } from '../../TeaserBox/TeaserBox.config';
/**
 * Base mixin for components that work with addons
 * Provides common functionality for addon component resolution and props
 */
let AddonsMixin = class AddonsMixin extends Vue {
    /**
     * Gets the component name for an addon
     */
    getAddonComponent(addon) {
        // Handle case where addon might be an array instead of single module
        const module = Array.isArray(addon) ? addon[0] : addon;
        return addonsRegistry[module === null || module === void 0 ? void 0 : module.driver] || 'div';
    }
    /**
     * Gets base props for addon component
     * This is the basic version - extend in subclasses for more specific props
     */
    getAddonProps(addon) {
        // Handle case where addon might be an array instead of single module
        const module = Array.isArray(addon) ? addon[0] : addon;
        return {
            ...this.addonProps,
            module: module
        };
    }
};
__decorate([
    Prop({ type: Object, required: false, default: () => ({}) })
], AddonsMixin.prototype, "addonProps", void 0);
AddonsMixin = __decorate([
    Component({
        name: 'AddonsMixin'
    })
], AddonsMixin);
export { AddonsMixin };
